import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import PrivateRoute from "./services/PrivateRoute";
import Login from "./pages/Login";
import FamiliaCriar from "./pages/familias/Criar";
import FamiliaListar from "./pages/familias/Listar";
import FamiliaEditar from "./pages/familias/Editar";
import ArtigosCriar from "./pages/artigos/Criar";
import ArtigoListar from "./pages/artigos/Listar";
import ArtigosEditar from "./pages/artigos/Editar";
import ArtigoListarTodos from "./pages/artigos/ListarTodos";
import FamiliaFicha from "./pages/familias/Ficha";
import ArtigoFicha from "./pages/artigos/Ficha";
import ClientesListar from "./pages/clientes/Listar";
import ClientesListarTodos from "./pages/clientes/ListarTodos";
import ClienteCriar from "./pages/clientes/Criar";
import ClienteFicha from "./pages/clientes/Ficha";
import ClienteEditar from "./pages/clientes/Editar";
import DocumentosCriar from "./pages/documentos/Criar";
import DocumentosListar from "./pages/documentos/Listar";
import DocumentosVer from "./pages/documentos/VerDocumento";
import DocumentosEditar from "./pages/documentos/Editar";
import UtilizadoresListar from "./pages/utilizadores/Listar";
import UtilizadorFicha from "./pages/utilizadores/Ficha";
import Dashboard from "./pages/Dashboard";
import DocumentosCriarTeclado from "./pages/documentos/CriarTeclado";
import ReceberEncomenda from "./pages/armazem/ReceberEncomenda";
import {Auth} from "./pages/Auth";
import ArmazemListar from "./pages/armazem/Listar";
import ArmazemDetalhes from "./pages/armazem/VerDocumento";
import ArmazemEditar from "./pages/armazem/Editar";
import FornecedorListar from "./pages/fornecedores/Listar";
import FornecedorFicha from "./pages/fornecedores/Ficha";
import SalesManRoute from "./services/SalesManRoute";
import WarehouseRoute from "./services/WarehouseRoute";
import AdminRoute from "./services/AdminRoute";
import RegistoDiario from "./pages/RegistoDiario";
import ClienteSetItems from "./pages/clientes/SetItems";
import DocumentosCriarLista from "./pages/documentos/CriarLista";
import SystemCostumer from "./pages/clientes/systemCostumer";
import DocumentosCriarHistorico from "./pages/documentos/CriarHistorico";

const Routes = () => (
    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={Login} />
            {/*<Route exact path="/public" component={Login} />*/}
            <Route exact path="/auth/:authToken" component={Auth} />

            <PrivateRoute exact path="/familias" component={FamiliaListar} />
            <PrivateRoute path="/familias/criar" component={FamiliaCriar} />
            <PrivateRoute path="/familias/editar/:id" component={FamiliaEditar} />
            <PrivateRoute exact path="/familias/:id" component={FamiliaFicha} />

            <PrivateRoute exact path="/artigos" component={ArtigoListar}/>
            <PrivateRoute exact path="/artigos/todos" component={ArtigoListarTodos}/>
            <PrivateRoute exact path="/artigos/criar" component={ArtigosCriar}/>
            <PrivateRoute exact path="/artigos/editar/:id" component={ArtigosEditar}/>
            <PrivateRoute exact path="/artigos/:id" component={ArtigoFicha}/>

            <SalesManRoute exact path="/clientes" component={ClientesListar} />
            <SalesManRoute exact path="/clientes/todos" component={ClientesListarTodos} />
            <SalesManRoute exact path="/clientes/criar" component={ClienteCriar} />
            <SalesManRoute exact path="/clientes/editar/:id" component={ClienteEditar} />
            <SalesManRoute exact path="/clientes/artigos/:id" component={ClienteSetItems} />
            <SalesManRoute exact path="/clientes/:id" component={ClienteFicha} />

            <SalesManRoute exact path="/documentos" component={DocumentosCriar} />
            <SalesManRoute exact path="/documentos/teclado" component={DocumentosCriarTeclado} />
            <SalesManRoute exact path="/documentos/criarlista" component={DocumentosCriarLista} />
            <SalesManRoute exact path="/documentos/criarHistorico" component={DocumentosCriarHistorico} />
            <SalesManRoute exact path="/documentos/lista" component={DocumentosListar} />
            <SalesManRoute exact path="/documentos/ver/:id" component={DocumentosVer} />
            <SalesManRoute exact path="/documentos/editar/:id" component={DocumentosEditar} />
            <SalesManRoute path="/registos/:cliente?" component={RegistoDiario}/>


            <SalesManRoute exact path="/fornecedores" component={FornecedorListar} />
            <SalesManRoute exact path="/fornecedores/:id" component={FornecedorFicha} />

            {/*<PrivateRoute exact path="/tara" component={DevolverTara} />*/}
            {/*<PrivateRoute exact path="/pagamentos" component={Pagamento} />*/}

            <AdminRoute exact path="/utilizadores" component={UtilizadoresListar} />
            <AdminRoute exact path="/utilizadores/:id" component={UtilizadorFicha} />

            <WarehouseRoute exact path="/armazem/receberEncomenda" component={ReceberEncomenda} />
            <WarehouseRoute exact path="/armazem" component={ArmazemListar} />
            <WarehouseRoute exact path="/armazem/ver/:id" component={ArmazemDetalhes} />
            <WarehouseRoute exact path="/armazem/editar/:id" component={ArmazemEditar} />

            <AdminRoute exact path="/systemCostumer" component={SystemCostumer} />


            <PrivateRoute path="/dashboard" component={Dashboard} />


            <Route path="*" component={() => <h1>Page not found</h1>} />
        </Switch>
    </BrowserRouter>
);

export default Routes;
